import React from 'react';
import Trial from '../../../sections/Bookfreetrial/Trial';
import Footer from '../../../sections/Footer/Footer';
import Header from '../../../sections/Header/Header';
import CoursesPicContQWT from '../../../sections/TitleBgCourses/CoursesPicContQWT/CoursesPicContQWT';
import TitleBgCoursesQWT from '../../../sections/TitleBgCourses/TitlepicCourses/TitleBgCoursesQWT/TitleBgCoursesQWT';

const CoursesQWT = ()=>{
    return(
        <div>
            <Header/>
            <TitleBgCoursesQWT/>
            <CoursesPicContQWT/>
            <Trial/>
            <Footer/>
        </div>
    )
}

export default CoursesQWT;